import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { AuthService } from 'src/app/services/auth.service';
import { AdministradorService } from 'src/app/services/administrador.service';
import { TotalesGenerales } from 'src/app/models/totales-generales.interface';
import { HttpRespuesta } from 'src/app/models/http-respuesta.interface';

@Component({
  selector: 'app-administrador',
  templateUrl: './administrador.component.html',
  styleUrls: ['./administrador.component.scss']
})
export class AdministradorComponent implements OnInit {
  public totalesGenerales: TotalesGenerales | undefined;

  get totales(): TotalesGenerales | undefined {
    return this.totalesGenerales;
  }

  constructor(private administradorService: AdministradorService, public authService: AuthService) {

  }

  ngOnInit(): void {
    this.obtenerInformacion();
  }

  obtenerInformacion() {
    this.administradorService.totales()
      .subscribe({
        next: (response: TotalesGenerales) => { this.totalesGenerales = response; },
        error: (err: HttpErrorResponse) => console.log(err),
      })
  }
}
